import { Typography } from '@carto/meridian-ds/components'
import { Box, styled } from '@mui/material'
import { useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { isInIframe } from 'app/utils/embedding'
import { useCheckMapAccess } from 'features/auth-redirect/hooks/authRedirectHooks'
import { ResourceType } from 'features/common'
import AuthenticationPrompt from 'app/ui/AuthenticationPrompt'
import { redirectToAccounts } from 'features/auth-redirect/api/authenticationUtils'

import mapPlaceholderImage from 'assets/img/map-placeholder.webp'

const Background = styled(Box)(() => ({
  width: '100%',
  height: '100vh',
  background: `url('${mapPlaceholderImage}') lightgray 50% / cover no-repeat`,
  '&:before': {
    content: "''",
    display: 'block',
    height: '100vh',
    width: '100%',
    backdropFilter: 'blur(8px)'
  }
}))

export function BuilderLoginPromptUi({ queryResult }) {
  const showBackground = queryResult.data && !queryResult.data?.autoRedirect

  const contentMessageId = isInIframe ? 'builder.loginPrompt.contentEmbedded' : 'builder.loginPrompt.content'

  return (
    <>
      {showBackground && <Background />}
      <AuthenticationPrompt queryResult={queryResult} resourceType={ResourceType.Map}>
        <Box p={2}>
          <Typography variant="subtitle1">
            <FormattedMessage id="builder.loginPrompt.title" />
          </Typography>
        </Box>
        <Box px={2} flex={1}>
          <Typography variant="body2" color="textSecondary">
            <FormattedMessage id={contentMessageId} />
          </Typography>
        </Box>
      </AuthenticationPrompt>
    </>
  )
}

function BuilderLoginPrompt() {
  const { mapId } = useParams()
  const queryResult = useCheckMapAccess(mapId as string)

  if (!mapId) {
    redirectToAccounts()
    return null
  }

  return <BuilderLoginPromptUi queryResult={queryResult} />
}

export default BuilderLoginPrompt
